import React, { SVGProps } from 'react';

export const SvgLunker = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_379_19486)">
        <path
          d="M18.4978 9.30338L15.6419 11.1581L12.9173 6.46387C12.6054 6.80855 12.1459 7.00551 11.6699 7.02192C11.2924 7.02192 10.9313 6.90703 10.6358 6.67724L8.07534 11.1253L5.36714 9.31979C5.12094 9.97633 4.48081 10.4031 3.75863 10.4195C3.57808 10.4195 3.39753 10.3867 3.2334 10.3374L3.44677 19.611C3.44677 19.9721 3.75863 20.2511 4.11972 20.2511H19.7288C20.1063 20.2675 20.4018 19.9885 20.4018 19.6274L20.6152 10.2389C20.4346 10.3046 20.2377 10.3374 20.0571 10.3374C19.3677 10.3374 18.7604 9.92709 18.4978 9.31979V9.30338ZM18.941 18.7903H14.0334L18.941 14.1453V18.7903Z"
          fill="currentColor"
        />
        <path
          d="M4.7266 6.46385C4.7266 5.24926 3.69256 4.24805 2.42873 4.24805C1.1649 4.24805 0.130859 5.24926 0.130859 6.46385C0.130859 7.67844 1.1649 8.67966 2.42873 8.67966C3.69256 8.67966 4.7266 7.67844 4.7266 6.46385Z"
          fill="currentColor"
        />
        <path
          d="M11.7354 4.92099C12.9992 4.92099 14.0332 3.91977 14.0332 2.70519C14.0332 1.4906 12.9992 0.48938 11.7354 0.48938C10.4715 0.48938 9.4375 1.4906 9.4375 2.70519C9.4375 3.91977 10.4715 4.92099 11.7354 4.92099Z"
          fill="currentColor"
        />
        <path
          d="M21.2383 4.24805C19.9745 4.24805 18.9404 5.24926 18.9404 6.46385C18.9404 7.67844 19.9745 8.67966 21.2383 8.67966C22.5021 8.67966 23.5362 7.67844 23.5362 6.46385C23.5362 5.24926 22.5021 4.24805 21.2383 4.24805Z"
          fill="currentColor"
        />
        <path
          d="M19.1209 21.9909H4.69352C3.99552 21.9909 3.42969 22.5567 3.42969 23.2547C3.42969 23.9527 3.99552 24.5186 4.69352 24.5186H19.1209C19.8189 24.5186 20.3847 23.9527 20.3847 23.2547C20.3847 22.5567 19.8189 21.9909 19.1209 21.9909Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_379_19486">
          <rect
            width="23.4055"
            height="24.0292"
            fill="currentColor"
            transform="translate(0.130859 0.48938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
